"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryAllPaginated = void 0;
const _ = require("lodash");
function queryAllPaginated(apiInstance, queryFn, params, maxPages, startAfter, options) {
    return __awaiter(this, void 0, void 0, function* () {
        let moreResults = true;
        let allResults = [];
        let allIncluded = {};
        let index = 0;
        let prevNext;
        while (moreResults && (!maxPages || index < maxPages)) {
            try {
                const args = [
                    Object.assign({ startAfter, limit: 100 }, params),
                ];
                if (options)
                    args.push(options);
                const response = yield queryFn.apply(apiInstance, args);
                const data = response.data;
                const nextLink = data.links.next;
                const included = data.included;
                if (included) {
                    Object.keys(included).map((includedKey) => {
                        if (!allIncluded[includedKey]) {
                            allIncluded[includedKey] = included[includedKey];
                        }
                        else {
                            allIncluded[includedKey] = allIncluded[includedKey].concat(included[includedKey]);
                        }
                    });
                }
                allResults = allResults.concat(data.data);
                //if there is a next link, moreShows = true
                moreResults = !!nextLink;
                if (prevNext === nextLink) {
                    moreResults = false;
                }
                if (moreResults) {
                    const urlParams = new URLSearchParams(nextLink.split("?")[1]);
                    startAfter = urlParams.get("startAfter") || undefined;
                }
                index += 1;
                prevNext = nextLink;
            }
            catch (e) {
                console.log(e);
                moreResults = false;
            }
        }
        return { data: _.uniqBy(allResults, (obj) => obj.id), startAfter, included: allIncluded };
    });
}
exports.queryAllPaginated = queryAllPaginated;
